import {useEffect, useState} from 'react'
import {ISelectOption} from '../utils/core/_model'
import axios from 'axios'

type TUserType = {
  userType: ISelectOption[]
}

const useUserType = ({endpoint}: {endpoint: string}): TUserType => {
  const [userType, setUserType] = useState<ISelectOption[]>([])

  useEffect(() => {
    const getUserTypes = async () => {
      try {
        const response = await axios.get<{role_id: number; role_name: string}[]>(endpoint)
        const data = await response.data
        const formatted = data.map((type) => ({
          id: type.role_id,
          label: type.role_name,
          value: String(type.role_id),
        }))
        setUserType(formatted || [])
      } catch (error) {
        console.log(error)
      }
    }

    getUserTypes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {userType}
}

export default useUserType
